import React from 'react';
import './BottomBreadcrumb.scss';
import { Icons } from '../../../utilities';

const miniBottomBar = props => {
  const { handleSideBar, showSideBar, sidebarIsHiddenInDesktop } = props;

  return (
    <div>
      <div className='mini-bottom-bar-wrapper'>
        {!sidebarIsHiddenInDesktop ? (
          <div style={{ paddingLeft: '25px' }}>
            <button
              type='button'
              style={{ border: 'none', background: 'none', outline: 'none' }}
              onClick={() => handleSideBar(!showSideBar)}
            >
              <img src={Icons.content_show} alt='sidebar' />
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default miniBottomBar;
